const videoUrl =
  "https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-1080p.mp4";
const videoPoster =
  "https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.jpg";

function VideoSection() {
  return (
    <div className="mx-auto aspect-video w-full max-w-6xl overflow-hidden rounded-lg bg-gray-100">
      <video
        controls
        preload="auto"
        className="h-full w-full object-cover"
        poster={videoPoster} // we can take screenshot of the video and use it as poster
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}

export default VideoSection;
